import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { convertData } from '../../../../../helpers/value'
import EarningBreakdownEachYear from '../../common/earningBreakdown/EachYear'
import { getYearTabs, handleIconDownload } from '../../helper'
import { changeYear, selectYear } from '../../store/slice'
import {
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from './store/slice'

export const EachYear = ({ id, isDynamicReport, year: yearSetting }) => {
  const dispatch = useDispatch()

  const { multiplier, getExchangeRate } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )
  const year = useSelector(selectYear(id, yearSetting))
  const data = useSelector(selectDataViewByEachYear(year))
  const indicatorById = useSelector(selectIndicatorById)
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const setYear = (year) => dispatch(changeYear({ id, year }))

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  const dataConvert = convertData(
    data.map((item, index) => {
      const isFirstItem = index === 0
      const isLastItem = index === data.length - 1
      return {
        ...item,
        year,
        name: indicatorById[item.id]?.ratioName || '',
        value: item.value,
        color:
          isFirstItem || isLastItem
            ? '#006AA6'
            : item.value >= 0
            ? '#74B49A'
            : '#FF596A',
      }
    }),
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year', 'name', 'color'],
  )

  const isNoData = !data.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  return (
    <EarningBreakdownEachYear
      data={dataConvert}
      tabs={tabs}
      onChangeTab={setYear}
      isNoData={isNoData}
      yearKey={year}
      isDynamicReport={isDynamicReport}
    />
  )
}
